import { computed, ref } from "@vue/composition-api";
import store from "@/store";
import axios from "axios";
import router from "@/router";
import moment from "moment";
import { SLOT_TYPES, SOURCES } from "@/config/layoutConfig";
import { v4 as uuidv4 } from 'uuid';

export function useChatbotFake() {

    const isMyFirstMessage = computed(() => store.getters["chatbotFake/getIsFirstMessage"]);
    const currentStep = computed(() => store.getters["chatbotFake/getCurrentStep"]);
    const botResponses = store.getters["chatbotFake/getDefaultResponses"];
    const chat = computed(() => store.getters["chatbotFake/getChat"]);
    const lang = computed(() => store.getters["user/getPreferences"].lang);
    const myMessage = ref({
      from: 'me',
      completed: true,
      body: '',
      type: 'text'
    })
    const finalResponse = ref(null)
    const isFilterStep = ref(false)
    const currentFilters = ref({})
    const showReadyBtn = ref(true)
    const isScrollEnable = ref(false)
    const typeMetadata = ref('')

    const chooseTypeAction = (string)=> {
      const randomNum = getRandomNumber(1,5)
      const separate = string.split(" ")
      const isForCreate = separate.find((word)=> word === "crear" || word === "agregar" || word === "create" || word === "add")
      const isForList = separate.find((word)=> word === "lista" || word === "list")
      if (isForCreate) {
        setTimeout(() => {
          currentFilters.value = {}
          store.commit("chatbot/updateLoadinStatus", false);
          store.commit("chatbotFake/addMessage",
            {
              message: {
                from: 'bot',
                completed: false,
                body: 'Claro, te dirijo a la vista para que puedas agregar la cuenta maestra',
                type: 'text'
              },
              typeMessage: "section_master_account"
            }
          );
          store.commit("chatbotFake/setIsFirstMessage", true);
          store.commit("chatbotFake/setViewHasSidebar", true);
          store.commit("chatbot/setViewSidebarActive", true);
          store.commit("chatbotFake/setIsOpenLuxriotSidebar", true);
          router.push({ name: "luxriot_master_accounts" });
        }, randomNum*1000);
        return
      }

      if (isForList) {
        setTimeout(() => {
          currentFilters.value = {}
          store.commit("chatbot/updateLoadinStatus", false);
          const response = {
            body: "Aqui tienes el resultado:",
            from: "bot",
            completed: false,
            type: "card",
            value: {
                chart_id: "79836ce2-c9d9-4dd6-9201-df755e934f11",
                field: "event_type",
                model: "DetectionEvent",
                chart: "list",
                filters: {
                    data: [
                        "type,person",
                        "upper_body_color,contains|red"
                    ]
                }
            }
          }
          store.commit("chatbotFake/addMessage",{ message: response, typeMessage: "default_final_response"});
          store.commit("chatbotFake/setIsFirstMessage", true);
        }, randomNum*1000);
        return
      }

      finalResponse.value = null
      store.commit("chatbotFake/setAllMessagesCompleted");
      setTimeout(() => {
        currentFilters.value = {}
        store.commit("chatbot/updateLoadinStatus", false);
        store.commit("chatbotFake/addMessage", { message: {...botResponses.success}, typeMessage: "default_final_response"});
        store.commit("chatbotFake/setIsFirstMessage", true);
      }, randomNum*1000);
    }

    const analyzeFilterText = (text)=> {
      const randomNum = getRandomNumber(1,5)
      const query = text.replace(/[\n\r]/g, '');

      const separate = query.split(" ")
      let currentColor = ''
      let plate = ''
      const colors = [
        { name: "rojo", code: 'red'},
        { name: "azul", code: 'blue'},
        { name: "negro", code: 'black'},
        { name: "verde", code: 'green'},
        { name: "amarillo", code : 'yellow'},
      ]
      separate.forEach((word, index) => {
        if (word == 'color' || word == 'colores') {
          const findColor = colors.find(color => color.name == separate[index + 1])
          currentColor = findColor ? findColor.code : currentColor
        }
        if (word == 'placa' || word == 'placas' || word == 'plate' || word == 'plates') {
          plate = separate[index +1]
        }
      });
      
      if (typeMetadata.value === 'person') {
        if (lang.value === 'en') currentColor = 'blue'
        currentFilters.value['data'].push(`upper_body_color,contains|${currentColor}`)
      } else {
        if (lang.value === 'en') currentColor = 'red'
        if (plate) {
          currentFilters.value['data'].push(`plate,contains|${plate}`)
        }
        if (currentColor) {
          currentFilters.value['data'].push(`color,contains|${currentColor}`)
        }
      }

      finalResponse.value = generateResponse()
      setTimeout(() => {
        store.commit("chatbot/updateLoadinStatus", false);
        store.commit("chatbotFake/addMessage", {message: {...finalResponse.value}, typeMessage: "default_final_response"});
        store.commit("chatbotFake/updateCurrentStep", 0);
        store.commit("chatbotFake/setIsFirstMessage", true);
      }, randomNum*1000);
    }

    const setFinalProcess = ()=> {
      const currentEventType = computed(() => store.getters["chatbotFake/getCurrentEventType"])
      const randomNum = getRandomNumber(1,5)
      store.commit("chatbot/updateLoadinStatus", true);
      if (currentStep.value === 5 && !currentFilters.value['data']) {
        finalResponse.value = generateResponse()
        setTimeout(() => {
          store.commit("chatbot/updateLoadinStatus", false);
          store.commit("chatbotFake/addMessage", {message: {...finalResponse.value}, typeMessage: "default_final_response"});
          store.commit("chatbotFake/updateCurrentStep", 0);
          store.commit("chatbotFake/setIsFirstMessage", true);
        }, randomNum*1000);
        return
      }
      if (currentEventType.value === 'DetectionEvent') {
        setTimeout(() => {
          store.commit("chatbot/updateLoadinStatus", false);
          store.commit("chatbotFake/updateCurrentStep", 5);
          store.commit("chatbotFake/addMessage", { message:{...botResponses.metadata}, typeMessage: "sugestion_filters_metadata"});
        }, randomNum*1000);

      } else {
        finalResponse.value = generateResponse()
        setTimeout(() => {
          store.commit("chatbot/updateLoadinStatus", false);
          store.commit("chatbotFake/addMessage", {message: {...finalResponse.value}, typeMessage: "default_final_response"});
          store.commit("chatbotFake/updateCurrentStep", 0);
          store.commit("chatbotFake/setIsFirstMessage", true);
        }, randomNum*1000);
      }
    }

    const setFilter = (code, index, value, isMessageCompleted)=> {
      if (isMessageCompleted) return
      isFilterStep.value = true
      store.commit("chatbotFake/addMessage", { message: {from: 'me', completed: true, body: value, type: 'text'} });
      if (currentStep.value === 5) {
        currentFilters.value['data'] = []
        currentFilters.value['data'].push(`type,${index}`)
        typeMetadata.value = index
        store.commit("chatbotFake/updateStep",{index: 4, value: currentFilters.value});
        store.commit("chatbotFake/addMessage", { message:{...botResponses.metadataOption}, typeMessage: "metadataOption" });
        showReadyBtn.value = false
        return
      }
      if (code === 'date') {
        const date = index === '5' || index === '30' ? { time: 'minute', quantity: index } : { time: 'days', quantity: 1 }
        currentFilters.value['from'] = moment().subtract(date.quantity, date.time).format("YYYY-MM-DDTHH:mm")
        currentFilters.value['to'] = moment().format("YYYY-MM-DDTHH:mm")
      } else {
        currentFilters.value[`${code}`] = [index]
      }
      store.commit("chatbotFake/updateStep",{index: 4, value: currentFilters.value});
    }

    const fetchFilters = (option)=> {
      const url = `${window.__env.VUE_APP_BASE_URL}/v1/charts-api/get-model-options`

      axios.get(url,
        {
          params: { model: option.code, load_options: false },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'X-Host': window.__env.VUE_APP_BASE_URL,
            "X-localization": lang.value
          }
        })
        .then(({ data }) => {
          const filters = []
          data.data.filters.forEach(filter => {
            const getField = data.data.fields.find((field) => field.value === filter)
            const isTypeDate = getField.value === 'updated'
              || getField.value === 'detection_events.created_at'
              || getField.value === 'created'
            const dateOptions = { 5: '5 min', 30: '30 min', 24:'24 hrs' }
            if (getField) {
              const options = isTypeDate ? dateOptions : getField.options
              const firstThreeEntries = Object.entries(options).slice(0, 3);
              const firstThreeOptions = Object.fromEntries(firstThreeEntries);
              const filterFormat = {
                name:  getField.text,
                code: isTypeDate ? 'date' : getField.value,
                options: firstThreeOptions
              }
              filters.push(filterFormat)
            }
          });
          store.commit("chatbotFake/setFilters", filters);
        });
    }

    const onScroll = ()=> {
      isScrollEnable.value = true
    }

    const goToBottom = ()=> {
      if (isScrollEnable.value) return
      setTimeout(() => {
        if (!document.querySelectorAll(".message-item").length) return
          const container = document.getElementById("chatBotResponses");
          const element = document.querySelectorAll(".message-item");
          const bottom = element[element.length -1].offsetTop
          container.scrollTop = bottom;
      }, 100);
    }

    const onDrag = (response)=> {
      setSlotData(response)
    }

    const setSlotData = (response)=> {
      const chartData = response.value
      const source = null

      if (response.value?.chart === 'list') {
        store.dispatch("grid/setSlotData", {
          type: SLOT_TYPES.CHARTS_SDK_DATA,
          name: `CHART SDK DATA`,
          data: chartData,
        });
        return
      }

      store.dispatch("grid/setSlotData", {
        type: SLOT_TYPES.CHARTS_SDK,
        name: `Charts SDK`,
        data: {
          chartData,
          in_app_source: source,
        },
        source: source ? source : SOURCES.ALARM
      });
    }

    const generateResponse = ()=> {
      const stepsResponses = computed(() => store.getters["chatbotFake/getStepsResume"])
      const chartDataId = uuidv4();
      finalResponse.value = null
      let finalResponseC = {}
      store.commit("chatbotFake/setAllMessagesCompleted");
      if (stepsResponses.value['1'].value === 'pie' || stepsResponses.value['1'].value === 'bar') {
        finalResponseC = {
          body: 'Aqui tienes el resultado:',
          completed: false,
          from: 'bot',
          type: 'card',
          value: {
            id: chartDataId,
            chart_id: chartDataId,
            name: stepsResponses.value['2'].value,
            chart: stepsResponses.value['1'].value,
            field: stepsResponses.value['3'].value,
            model: stepsResponses.value['2'].value,
            filters: currentFilters.value
          }
        }
        return finalResponseC
      }

      finalResponseC = {
        body: 'Aqui tienes el resultado:',
        from: 'bot',
        completed: false,
        type: 'card',
        value: {
          chart_id: chartDataId,
          field: stepsResponses.value['3'].value,
          model: stepsResponses.value['2'].value,
          chart: stepsResponses.value['1'].value,
          filters: currentFilters.value
        }
      }
      return finalResponseC
    }
    const getRandomNumber = (min, max)=> {
      return Math.floor(Math.random() * (max - min)) + min;
    }

    const continueSteps = (option, hasFilters, isMessageCompleted)=> {
      if (hasFilters || isMessageCompleted) return
      store.commit("chatbotFake/setAllMessagesCompleted");
      const randomNum = getRandomNumber(1,5)
      store.commit("chatbot/updateLoadinStatus", true);
      store.commit("chatbotFake/addMessage", { message: { from: 'me', completed: true, body: option.name, type: 'text'} });

      if (currentStep.value === 0) {
        store.commit("chatbotFake/updateStep", {index: 1, value: option.code});
        store.commit("chatbotFake/updateCurrentStep", 1);
        setTimeout(() => {
          store.commit("chatbot/updateLoadinStatus", false);
          store.commit("chatbotFake/addMessage", { message: {...botResponses.typeEvent}, typeMessage: "type_event_select" });
        }, randomNum*1000);
        return
      }

      if (currentStep.value === 1) {
        store.commit("chatbotFake/updateStep",{index: 2, value: option.code});
        store.commit("chatbotFake/updateCurrentStep", 2);

        setTimeout(() => {
          store.commit("chatbot/updateLoadinStatus", false);
          store.commit("chatbotFake/addMessage", { message: {...botResponses[`group${option.code}`]}, typeMessage: "select_type_group" });
        }, randomNum*1000);

        fetchFilters(option)
        return
      }

      if (currentStep.value === 2) {
        store.commit("chatbotFake/updateStep",{index: 3, value: option.code});
        store.commit("chatbotFake/updateCurrentStep", 3);
        setTimeout(() => {
          store.commit("chatbot/updateLoadinStatus", false);
          showReadyBtn.value = true
          store.commit("chatbotFake/addMessage", { message: {...botResponses.filters}, typeMessage: "sugestion_filters" });
          store.commit("chatbotFake/updateCurrentStep", 4);
          currentFilters.value = {}
          typeMetadata.value = ''
        }, randomNum*1000);
      }
    }

    const messageHandler = (message)=> {
      if (message === '') return
      myMessage.value.body = message
      const randomNum = getRandomNumber(1,5)
      store.commit("chatbotFake/addMessage", { message: {...myMessage.value} });
      store.commit("chatbot/updateLoadinStatus", true);
      isScrollEnable.value = false

      if (message === 'salir modo super admin') {
        setLogSuperAdmin()
        return
      }

      if (currentStep.value === 5) {
        analyzeFilterText(myMessage.value.body)
        myMessage.value.body = ''
        return
      }

      if (myMessage.value.body.length > 39 && isMyFirstMessage.value) {
        chooseTypeAction(myMessage.value.body)
        myMessage.value.body = ''
        return
      }

      if (isMyFirstMessage.value) {
        store.commit("chatbotFake/setIsFirstMessage", false);
        setTimeout(() => {
          store.commit("chatbot/updateLoadinStatus", false);
          store.commit("chatbotFake/addMessage", { message: {...botResponses.welcome}, typeMessage: "welcome" });
        }, randomNum*1000);
      }

      myMessage.value.body = ''
    }

    const setLogSuperAdmin = ()=> {
      const logSuperAdmin = { from: 'bot', completed: true, body: 'Salio de modo super admin', type: 'text' }
      store.commit("chatbotFake/addMessage", { message: logSuperAdmin });
      store.commit("chatbot/updateLoadinStatus", false);
    }

    const reloadChat = () => {
      store.commit("chatbotFake/reloadChat");
      finalResponse.value = null
      isFilterStep.value = false
      currentFilters.value = {}
      typeMetadata.value = ''
      if (router.currentRoute.name === 'home') {
        store.commit("chatbotFake/setViewHasSidebar", false);
      }
    }

  return {
    messageHandler,
    myMessage,
    onDrag,
    setFilter,
    setFinalProcess,
    currentStep,
    showReadyBtn,
    continueSteps,
    onScroll,
    goToBottom,
    reloadChat,
    chat
  }
}